import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'web-ui-components/lib/global/layout';
import { PageHeading } from 'web-ui-components/lib/typography/headings';

const SiteHeader = ({ title, description }) => (
	<Container className="u-padding-bottom-4 u-padding-top-4" size="md">
		<div className="u-text-align-center">
			<PageHeading isFlush data-test-id="site-header">
				{title}
			</PageHeading>
			{description && <p className="u-margin-top-1 u-margin-bottom-0">{description}</p>}
		</div>
	</Container>
);

SiteHeader.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
};

export default SiteHeader;
